export enum FilterSectionIds {
  CreditProducts = 'creditProducts',
  Markets = 'markets',
  Currency = 'currency',
  Tenor = 'tenor',
  Status = 'status',
  MaturityDate = 'maturityDate',
  CouponTypes = 'couponTypes',
  Rankings = 'rankings',
  Ratings = 'ratings',
  RatingAgencies = 'ratingAgencies',
  Benchmarks = 'benchmarks',
  Registrations = 'registrations',
  CouponRange = 'couponRange',
  PricingSpread = 'pricingSpread',
  Yield = 'yield',
  XCovered = 'xCovered',
  IptPxd = 'iptPxd',
  Attrition = 'attrition',
  Size = 'size',
  AdditionalFilters = 'additionalFilters',
  IndustriesSubindustries = 'industriesSubindustries',
  RegionsCountries = 'regionsCountries',
  ParentsIssuers = 'parentsIssuers',
  Ticker = 'ticker',
  Esg = 'esg',
  UseOfProceeds = 'useOfProceeds',
  Listing = 'listing',
  Price = 'price',
  Leads = 'leads',
  CallDate = 'callDate',
}

export const REQUIRED_FILTER_LABELS: Record<string, string> = {
  [FilterSectionIds.CreditProducts]: 'one Credit Product',
  [FilterSectionIds.Markets]: 'one Market',
};
